import ProgramsPage from '@pages/settings/membership/ProgramsPage'
import { Navigate, RouteObject } from 'react-router-dom'
import programDetailRoutes from './ProgramDetailRoutes'

const programRoutes: RouteObject[] = [
  {
    children: [
      { path: 'list', element: <ProgramsPage /> },
      { index: true, element: <Navigate to="list" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
  {
    path: ':programSlug',
    children: programDetailRoutes,
  },
]

export default programRoutes
